import { Layout } from 'antd';
import React from 'react';
import './App.css';
import { Switch, Route, Redirect, HashRouter } from 'react-router-dom';
import { NavigationProvider } from './contexts/NavigationContext';
import routes from './AppRoutes';
const { Header, Content, Footer } = Layout;

function App() {

  return (
      <NavigationProvider>
        <HashRouter>
          <Layout>
            <Switch>
              {routes.map(({ path, component }) => (
                <Route
                  exact
                  key={path}
                  path={path}
                  component={component}
                />
              ))}
              <Redirect to={'/quotation-request'} />
            </Switch>
          </Layout>
        </HashRouter>
      </NavigationProvider>
  );
}

export default App;
